import React from 'react'
import { Button, Spinner } from 'react-bootstrap'
import { ArrowClockwise } from 'react-bootstrap-icons'
import useCacheKeys from '../../../hooks/use-cache-keys'
import useCache from '../../../hooks/use-cache'
import useJobs from '../../../hooks/use-jobs'

const ReloadButton = () => {
    const cacheKeys = useCacheKeys()
    const { clearCache } = useCache({ key: cacheKeys.JOBS })
    const { isLoading } = useJobs()

    if (isLoading) {
        return (
            <Spinner animation='grow' size='sm' />
        )
    }

    return (
        <Button
            variant='link'
            title='Refresh'
            onClick={() => clearCache()}
        >
            <ArrowClockwise />
        </Button>
    )
}

export default ReloadButton